function NameCell({ dataItem, field, hidden, accessedFromDesigner, onExpandChange, onEdit }) {
    const cellData = dataItem[field];

    function handleEdit() {
        onEdit(dataItem.id);
    }
    
    function handleExpandChange() {
        onExpandChange(dataItem.id);
    }

    let expand = <span className="k-icon k-i-none"></span>;;

    if (dataItem.actionDisplay === "Button Group") {
        if (dataItem.expanded) {
            expand = (
                <span
                    onClick={handleExpandChange}
                    className="k-icon k-i-collapse"
                ></span>
            );
        } else {
            expand = (
                <span
                    onClick={handleExpandChange}
                    className="k-icon k-i-expand"
                ></span>
            );
        }
    }

    return (
        <td style={{ width: "200px" }}>
            {expand}
            { hidden ? (
                <span className="text-muted">{String(cellData)}</span>
            ) : (
                <span
                    disabled={true}
                    className={accessedFromDesigner ? "link" : ""}
                    onClick={accessedFromDesigner ? handleEdit : null}
                >
                    {String(cellData)}
                </span>
            )}
        </td>
    );
}

export default NameCell;